import { isMobileBrowser } from 'jitsi/base/environment/utils';
export const isWebview = () => {
    let result = false;
    if (isMobileBrowser()) {
        const userAgent = window.navigator.userAgent.toLowerCase();
        const ios = /iphone|ipod|ipad/.test(userAgent);
        if (!ios) {
            if (userAgent.includes('wv')) {
                // Android webview
                result = true;
            }
        }
        ;
    }
    return result;
};
export default isWebview;
